import { ErrorReference, GraphQlRequestErrorCode } from '../api/types';
import { ErrorTypes } from './components/errors/types';

export class CustomError extends Error {
  constructor(
    readonly name: string,
    message?: string
  ) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export class GraphQLError extends CustomError {
  constructor(
    readonly error: Error,
    readonly errorReference: ErrorReference | null,
    readonly errorCode: GraphQlRequestErrorCode,
    readonly tags?: Record<string, string>,
    readonly errorType?: ErrorTypes
  ) {
    super(
      'GraphQLError',
      `Couldn't fetch data with error ${error.message} (error code: ${errorCode}). Error ref: ${
        errorReference ?? 'unknown'
      }`
    );
  }
}

export class NetworkError extends CustomError {
  constructor(readonly error: Error) {
    super('NetworkError', 'There was a network error');
  }
}
